import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative pt-28 md:pt-32 pb-12 md:pb-16 overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#0e0d0a] via-[#0a0a0a] to-[#0a0a0a]" />
      <div className="hero-glow top-[-20%] right-[-10%]" />
      <div className="container-x relative z-10">
        <nav className="mb-8 text-[11px] tracking-[0.26em] uppercase text-[#7a766d]">
          <Link to="/" className="hover:text-[var(--gold)] transition-colors">
            Strona główna
          </Link>
          <span className="mx-3">/</span>
          <span className="text-[var(--gold)]">{eyebrow}</span>
        </nav>
        <h1 className="h-display text-[clamp(26px,4.4vw,56px)] max-w-4xl leading-[1.1]">
          {title}
        </h1>
        <div className="gold-line mt-8" />
        {subtitle && (
          <p className="mt-6 text-[15px] md:text-[17px] leading-relaxed text-[#b8b3a7] max-w-2xl">
            {subtitle}
          </p>
        )}
        {children}
      </div>
    </section>
  );
}

export function PageCTA({ title, text, buttonLabel = "Porozmawiajmy", to = "/kontakt", secondary }) {
  return (
    <section className="relative py-20 md:py-28">
      <div className="container-x">
        <div className="relative border border-[rgba(212,169,74,0.3)] bg-gradient-to-br from-[#141210] via-[#0f0d0a] to-[#141210] p-10 md:p-16 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[var(--gold)] opacity-[0.05] blur-3xl" />
          <div className="relative z-10 grid grid-cols-1 md:grid-cols-3 gap-10 items-center">
            <div className="md:col-span-2">
              <h2 className="h-display text-[clamp(28px,3.6vw,44px)]">
                {title}
              </h2>
              {text && (
                <p className="mt-5 text-[16px] leading-relaxed text-[#b8b3a7] max-w-2xl">
                  {text}
                </p>
              )}
            </div>
            <div className="flex flex-col gap-3 md:items-end">
              <Link to={to} className="btn-gold" data-testid="page-cta-primary">
                {buttonLabel}
                <ArrowRight size={16} />
              </Link>
              {secondary && (
                <Link to={secondary.to} className="btn-link" data-testid="page-cta-secondary">
                  {secondary.label}
                  <ArrowRight size={14} />
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
